import useTitle from "hooks/useTitle";
import authStore from "stores/authStore";

const HomePage = () => {
  const { firstName, lastName } = authStore.useState((s) => ({
    firstName: s.firstName,
    lastName: s.lastName,
  }));

  useTitle(undefined, true);

  return (
    <div>
      <h1>Knowfully Admin</h1>
      <p style={{ fontSize: "16px" }}>
        Welcome back {firstName} {lastName}
      </p>
    </div>
  );
};

export default HomePage;
